export default __webpack_public_path__ + "static/media/ddf-tigertones-app-icon.c49a0357.png";